import { render, staticRenderFns } from "./lactateTextList.vue?vue&type=template&id=34932618&scoped=true"
import script from "./lactateTextList.vue?vue&type=script&lang=js"
export * from "./lactateTextList.vue?vue&type=script&lang=js"
import style0 from "./lactateTextList.vue?vue&type=style&index=0&id=34932618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34932618",
  null
  
)

export default component.exports